import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

class ErrorBoundary extends React.Component {
 constructor(props) {
 super(props);
 this.state = { hasError: false, error: null, errorInfo: null };
 }

 static getDerivedStateFromError(error) {
 // 更新 state 使下一次渲染能够显示降级后的 UI
 return { hasError: true };
 }

 componentDidCatch(error, errorInfo) {
 // 你同样可以将错误日志上报给服务器
 console.error('ErrorBoundary caught an error:', error, errorInfo);
 this.setState({
 error: error,
 errorInfo: errorInfo
 });
 }

 handleReset = () => {
 this.setState({ hasError: false, error: null, errorInfo: null });
 // 如果提供了重置回调，调用它
 if (this.props.onReset) {
 this.props.onReset();
 }
 };

 render() {
 if (this.state.hasError) {
 // 你可以自定义降级后的 UI 并渲染
 return (
 <div className="min-h-screen flex items-center justify-center bg-cream-100 p-4">
 <div className="max-w-md w-full bg-cream-50 rounded-2xl shadow-xl p-8 text-center">
 <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
 <AlertCircle className="w-8 h-8 text-red-600" />
 </div>
 
 <h2 className="text-xl font-bold text-ink-900 mb-2">
 {this.props.title || '出现了一些问题'}
 </h2>
 
 <p className="text-ink-600 mb-6">
 {this.props.message || '页面遇到了错误，请尝试刷新页面。'}
 </p>
 
 {/* 只在开发环境显示错误详情 */}
 {process.env.NODE_ENV === 'development' && this.state.error && (
 <details className="mb-6 text-left">
 <summary className="cursor-pointer text-sm text-ink-500 hover:text-ink-700">
 查看错误详情
 </summary>
 <div className="mt-2 p-3 bg-cream-100 rounded-lg">
 <p className="text-xs font-mono text-red-600 break-all">
 {this.state.error.toString()}
 </p>
 {this.state.errorInfo && (
 <pre className="mt-2 text-xs text-ink-600 overflow-auto max-h-40">
 {this.state.errorInfo.componentStack}
 </pre>
 )}
 </div>
 </details>
 )}
 
 <div className="flex gap-3 justify-center">
 <button
 onClick={this.handleReset}
 className="px-6 py-2 bg-accent-500 text-white rounded-lg font-medium hover:bg-accent-600 transition-colors flex items-center gap-2"
 >
 <RefreshCw className="w-4 h-4" />
 重试
 </button>
 
 <button
 onClick={() => window.location.reload()}
 className="px-6 py-2 border border-ink-300 text-ink-700 rounded-lg font-medium hover:bg-cream-100 transition-colors"
 >
 刷新页面
 </button>
 </div>
 </div>
 </div>
 );
 }

 return this.props.children;
 }
}

export default ErrorBoundary;